export const currencyRound = (price: number, currencyCode: string) => {
  const precision = (currencyCode.toLowerCase() === 'czk' ? 1 : 100);
  return Math.round(price * precision) / precision;
};


// WEBPACK FOOTER //
// ../helpers/src/currency/currencyRound.ts